let loadedData = null
let loadingPromise = null

/**
 * Lazily loads the Spanish locations data from the JSON file.
 * Ensures the data is fetched only once.
 */
export async function loadSpainLocations() {
  if (loadedData) {
    return loadedData
  }

  if (loadingPromise) {
    return loadingPromise
  }

  loadingPromise = import('./spain-locations.json').then((module) => {
    // Sort provinces and municipalities alphabetically by name
    const data = module.default
    data.provincias.sort((a, b) => a.nombre.localeCompare(b.nombre))
    data.provincias.forEach((provincia) => {
      provincia.municipios.sort((a, b) => a.nombre.localeCompare(b.nombre))
    })
    loadedData = data
    loadingPromise = null // Clear the promise once loaded
    return loadedData
  })

  return loadingPromise
}

/**
 * Finds province, municipio, and postal codes based on a partial postal code.
 */
export function findLocationByPostalCode(postalCode, data) {
  if (!data || postalCode.length < 2) {
    return {}
  }

  for (const provincia of data.provincias) {
    for (const municipio of provincia.municipios) {
      if (municipio.codigosPostales.some((cp) => cp.startsWith(postalCode))) {
        // If a full 5-digit match is found, return immediately
        if (municipio.codigosPostales.includes(postalCode)) {
          return { provincia, municipio }
        }
        // Otherwise, continue searching for a full match in other municipios/provincias
        // If no full match is found later, this partial match might be returned if it's the only one
      }
    }
  }
  // If no exact match after checking all, check again for the first partial match found
  // This handles cases where user types less than 5 digits

  //no-loop-func
  for (const provincia of data.provincias) {
    for (const municipio of provincia.municipios) {
      if (municipio.codigosPostales.some((cp) => cp.startsWith(postalCode))) {
        return { provincia, municipio }
      }
    }
  }

  return {}
}
